<template>
  <panel
    :icon="'calendar'"
    :heading="label"
  >
    Countdown
  </panel>
</template>

<script>
import Panel from '@components/singletons/panel.vue';

export default {
  components: { Panel },
  props: {
    label: {
      type: String,
      default: '',
    },
  },
};
</script>

<style lang='scss' scoped>

</style>
